import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getActiveEvent, getGenerelleIndstillinger, FALLBACK_GENERELLT } from '../lib/cms';

export default function Footer() {
  const [eventData, setEventData] = useState(null);
  const [info, setInfo] = useState(FALLBACK_GENERELLT);

  useEffect(() => {
    getActiveEvent().then(setEventData);
    getGenerelleIndstillinger().then(data => {
      if (data) setInfo(data);
    });
  }, []);

  const billetlink = eventData?.billetlink || "https://billet.eventbilletten.dk/seller/foreningen-rbike-zd1k";

  return (
    <footer className="bg-[#06070a] border-t border-pink-500/20 text-slate-400 text-sm">
      {/* Top Banner med næste event og CTA */}
      <div className="bg-gradient-to-r from-pink-950/40 via-purple-950/40 to-slate-900/60 border-b border-pink-500/10 py-8 px-4 sm:px-6 lg:px-8">
        <div className="max-w-[1520px] mx-auto flex flex-col md:flex-row items-center justify-between gap-6 text-center md:text-left">
          <div>
            <span className="inline-block px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider bg-pink-500/20 text-pink-400 border border-pink-500/30 mb-2">
              Næste store cykelfest
            </span>
            <h3 className="text-2xl sm:text-3xl font-extrabold text-white font-display uppercase tracking-wide">
              ØrBike 2026 – Lørdag den 14. november 2026
            </h3>
            <p className="text-slate-300 text-sm mt-1">
              Ørbæk Midtpunkt, Langemosevej 5, 5853 Ørbæk • 10 timers spinning til fordel for børn med kritisk sygdom
            </p>
          </div>
          <a
            href={billetlink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2.5 px-8 py-3.5 rounded-full bg-gradient-to-r from-pink-500 to-purple-600 text-white font-bold text-sm uppercase tracking-wider shadow-[0_0_25px_rgba(255,42,141,0.5)] hover:shadow-[0_0_35px_rgba(255,42,141,0.8)] transition-all hover:scale-105"
          >
            <i className="fa-solid fa-ticket" aria-hidden="true"></i>
            <span>Køb billet på Eventbilletten</span>
          </a>
        </div>
      </div>

      {/* Main Footer Links */}
      <div className="max-w-[1520px] mx-auto px-4 sm:px-6 lg:px-8 py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
        {/* Kolonne 1: Brand & Slogan */}
        <div className="space-y-4">
          <Link to="/" className="inline-block">
            <img 
              src="https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/orbike-logo-1.png" 
              alt="Foreningen ØrBike Logo" 
              className="h-12 w-auto object-contain"
            />
          </Link>
          <p className="text-slate-300 font-medium">
            Sammen skaber vi smil, ét tråd ad gangen.
          </p>
          <p className="text-xs text-slate-400 leading-relaxed">
            Med over 230 cykler og mere end 1.000 deltagere er ØrBike et af Danmarks største indendørs spinning- og velgørenhedsevents.
          </p>
          <div className="flex items-center gap-3 pt-2">
            <a 
              href={info.facebook_url || "https://www.facebook.com/Orbike/"} 
              target="_blank" 
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-full bg-slate-900 border border-pink-500/30 flex items-center justify-center text-pink-400 hover:text-white hover:bg-pink-500 hover:border-pink-500 transition-all"
              aria-label="Besøg ØrBike på Facebook"
            >
              <i className="fa-brands fa-facebook-f" aria-hidden="true"></i>
            </a>
            <a 
              href={info.instagram_url || "https://www.instagram.com/orbike_eventet/"} 
              target="_blank" 
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-full bg-slate-900 border border-pink-500/30 flex items-center justify-center text-pink-400 hover:text-white hover:bg-pink-500 hover:border-pink-500 transition-all"
              aria-label="Besøg ØrBike på Instagram"
            >
              <i className="fa-brands fa-instagram" aria-hidden="true"></i>
            </a>
            <a 
              href={info.youtube_url || "https://www.youtube.com/channel/UCbp5b3RJPR4NbWml_U-joHw"} 
              target="_blank" 
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-full bg-slate-900 border border-pink-500/30 flex items-center justify-center text-pink-400 hover:text-white hover:bg-pink-500 hover:border-pink-500 transition-all"
              aria-label="Besøg ØrBike på YouTube"
            >
              <i className="fa-brands fa-youtube" aria-hidden="true"></i>
            </a>
          </div>
        </div>

        {/* Kolonne 2: Hurtige Links */}
        <div>
          <h4 className="text-white font-bold text-base uppercase tracking-wider font-display mb-4 flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-pink-500"></span>
            Hurtige links
          </h4>
          <ul className="space-y-2.5">
            <li>
              <Link to="/eventet" className="hover:text-pink-400 transition-colors">
                ØrBike Eventet
              </Link>
            </li>
            <li>
              <Link to="/billetter" className="hover:text-pink-400 transition-colors">
                Billetter & Forplejning
              </Link>
            </li>
            <li>
              <Link to="/godt-formaal" className="hover:text-pink-400 transition-colors">
                Godt formål (Børn m/ kritisk sygdom)
              </Link>
            </li>
            <li>
              <Link to="/priority-cykler" className="hover:text-pink-400 transition-colors">
                Priority Cykler til firmaer
              </Link>
            </li>
            <li>
              <Link to="/partnere" className="hover:text-pink-400 transition-colors">
                Partnere & Sponsorer
              </Link>
            </li>
            <li>
              <Link to="/orbike-365" className="text-pink-400 hover:text-pink-300 font-semibold transition-colors flex items-center gap-1.5">
                <i className="fa-solid fa-star text-[10px]" aria-hidden="true"></i>
                <span>ØrBike 365 (Medlemskab)</span>
              </Link>
            </li>
          </ul>
        </div>

        {/* Kolonne 3: Mere om ØrBike */}
        <div>
          <h4 className="text-white font-bold text-base uppercase tracking-wider font-display mb-4 flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-purple-500"></span>
            Information
          </h4>
          <ul className="space-y-2.5">
            <li>
              <Link to="/om-os" className="hover:text-pink-400 transition-colors">
                Om Foreningen ØrBike
              </Link>
            </li>
            <li>
              <Link to="/praktisk-info" className="hover:text-pink-400 transition-colors">
                Praktisk info & FAQs
              </Link>
            </li>
            <li>
              <Link to="/fotoarkiv" className="hover:text-pink-400 transition-colors">
                Fotoarkiv & Stemning
              </Link>
            </li>
            <li>
              <Link to="/regnskaber" className="hover:text-pink-400 transition-colors">
                Officielle Årsregnskaber
              </Link>
            </li>
            <li>
              <Link to="/kontakt" className="hover:text-pink-400 transition-colors">
                Kontakt arrangørerne
              </Link>
            </li>
          </ul>
        </div>

        {/* Kolonne 4: Kontakt & CVR */}
        <div className="space-y-3">
          <h4 className="text-white font-bold text-base uppercase tracking-wider font-display mb-4 flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-pink-500"></span>
            {info.foreningsnavn || "Foreningen ØrBike"}
          </h4>
          <p className="text-slate-300 font-semibold text-sm">
            Eventarrangører: {info.arrangoerer || "Helle Holst Hansen og Jonas Reinholdt Albjerg"}
          </p>
          <p className="text-xs text-slate-400 whitespace-pre-line">
            {info.adresse || "C/O Jonas Reinholdt Albjerg\nDegnemosen 12, Tåsinge\n5700 Svendborg"}
          </p>
          <div className="pt-2 space-y-1.5 text-xs sm:text-sm">
            <p>
              <strong className="text-slate-200">CVR:</strong>{" "}
              <span className="whitespace-nowrap font-mono text-slate-300">{info.cvr || "45950433"}</span>
            </p>
            <p>
              <strong className="text-slate-200">Telefon:</strong>{" "}
              <a 
                href={`tel:${info.telefon ? info.telefon.replace(/[^0-9+]/g, '') : '4530936272'}`} 
                className="whitespace-nowrap text-pink-400 hover:text-pink-300 underline decoration-pink-500/40 transition-colors"
              >
                {info.telefon || "+45 30 93 62 72"}
              </a>
            </p>
            <p>
              <strong className="text-slate-200">Email:</strong>{" "}
              <a 
                href={`mailto:${info.email || 'info@orbike.dk'}`} 
                className="whitespace-nowrap text-pink-400 hover:text-pink-300 underline decoration-pink-500/40 transition-colors"
              >
                {info.email || "info@orbike.dk"}
              </a>
            </p>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800/80 bg-black/40 py-6 px-4 text-center text-xs text-slate-500">
        <div className="max-w-[1520px] mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
          <p>© {new Date().getFullYear()} Foreningen ØrBike. Alle rettigheder forbeholdes.</p>
          <p className="text-slate-400">
            Eventsted: <span className="text-slate-300">Ørbæk Midtpunkt, Langemosevej 5, 5853 Ørbæk</span>
          </p>
        </div>
      </div>
    </footer>
  );
}
